<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Select Attendees</h3>
            <div style="margin-bottom: 20px; max-height: 300px; overflow: auto;">
                <div v-if="!localEmployees.length">No employees to select.</div>
                <div v-for="(emp, i) in localEmployees" :key="i" class="checkbox-input">
                    <input type="checkbox" v-model="emp.selected" />
                    <div>{{ emp.Name }}</div>
                </div>
            </div>
            <input type="submit" :value="submitLabel || 'Save'" @click="save()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SelectMeetingAttendees',
    // submitLabel: the button's text (Run Meeting's is Start Meeting, which starts the meeting on save)
    props: [ 'employees', 'attendeeIds', 'submitLabel' ],
    data() {
        return {
            localEmployees: [] as any
        }
    },
    created() {
        this.localEmployees = this.$props.employees.map((emp: any) => ({
            ...emp,
            selected: (this.$props.attendeeIds || []).includes(emp.ID)
        }));
    },
    methods: {
        save() {
            const ids = this.localEmployees.filter((emp: any) => emp.selected).map((emp: any) => emp.ID);
            this.$emit('save', ids);
        }
    }
})
</script>
